import moment from "moment-timezone";
import HireneuronToolTip from "../../../components/HireneuronTable_copy/HireneuronToolTip";
import { CANDIDATE_STAGE, IN_PROGRESS } from "../globalVariables/globalData";
import { v1 } from "uuid";
import { Spinner } from "reactstrap";

export const subloaderStyle = {
  position: "absolute",
  zIndex: "1000",
  top: "77%",
  left: "50%",
  transform: "translate(-50%, -50%)",
};

export const loaderStyle = {
  position: "fixed",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
};

export const subspinnerStyle = { width: "3.5rem", height: "3.5rem" };

export const verifyData = (data) => {
  return data !== undefined && data !== null && data !== "";
};

export const verifyDataExcEmpty = (data) => {
  return data !== undefined && data !== null;
};

export const getNullIfEmpty = (data) => {
  if (data === "") {
    return null;
  }
  return data;
};

export const getEmptyIfNull = (data) => {
  if (data == null) {
    return "";
  }
  return data;
};

export const isListEmpty = (list) => {
  if (list == null || list == undefined) {
    return true;
  }
  return list.length > 0;
};

export const getNAIfInvalid = (...dataList) => {
  const validValue = dataList.find(
    (data) =>
      data !== undefined &&
      data !== null &&
      data !== "" &&
      data !== "null" &&
      data !== "undefined",
  );

  return validValue ?? "NA";
};

export const getEmptyIfInvalid = (data) => {
  if (verifyData(data)) {
    return data;
  }
  return "";
};

export const getFormattedDateElseNA = (...dataList) => {
  const validValue = dataList.find(
    (data) =>
      data !== undefined &&
      data !== null &&
      data !== "" &&
      data !== "null" &&
      data !== "undefined",
  );

  if (!validValue) return "NA";

  const formattedInput =
    typeof validValue === "string" ? validValue.replace(".0", "Z") : validValue;

  const date = moment(formattedInput);

  if (!date.isValid()) return "NA";

  return date.format("ll");
};

export const verifySalary = (data) => {
  return (
    data !== undefined &&
    data !== null &&
    data !== "" &&
    data !== "0.0" &&
    data !== "NA"
  );
};
//change string into capitalize
export function Capitalize(str) {
  if (str !== undefined && str !== null) {
    return str?.charAt(0).toUpperCase() + str?.slice(1).toLowerCase();
  }
}

//setter function for reduce complexity
export const setterFunction = (value, setter) => {
  if (verifyData(value)) {
    setter(value);
  }
};

export const assignCSSClass = (data, setter) => {
  if (verifyData(data)) {
    if (data === CANDIDATE_STAGE.ACCEPTED) {
      setter("badge badge-soft-success font-14");
    } else if (data === CANDIDATE_STAGE.REJECTED || data === "REJECT") {
      setter("badge badge-soft-danger font-14");
    } else if (data === IN_PROGRESS) {
      setter("badge badge-soft-info font-14");
    }
  }
};

/**
 * @property  {function} checkInterviewType This function returns the interview type
 * @param {String} data tyoe of interview
 */
export function checkInterviewType(data) {
  switch (data) {
    case "FACETOFACE":
      return "Face to Face";
    case "VIDEOCONFERENCE":
      return "Video Conferencing";
    case "TELEPHONIC":
      return "Telephonic";
    case "AIINTERVIEW":
      return "AI Interview";
    default:
      return null;
  }
}

/**
 * @property  {function} getInterviewClassNames This function returns text class for text color
 * @param {String} data hiring stage
 */
export function getInterviewClassNames(obj) {
  if (obj === CANDIDATE_STAGE.COMPLETED) {
    return "text-success";
  } else if (obj === CANDIDATE_STAGE.REJECTED || obj === "REJECT") {
    return "text-danger";
  } else if (obj === CANDIDATE_STAGE.SCHEDULED) {
    return "text-info";
  } else if (obj === IN_PROGRESS) {
    return "text-info";
  } else if (obj === CANDIDATE_STAGE.HIRED) {
    return "text-success";
  } else if (obj === CANDIDATE_STAGE.HIRE) {
    return "text-success";
  } else if (obj === CANDIDATE_STAGE.REVIEWED) {
    return "text-success";
  } else if (obj === CANDIDATE_STAGE.S_JD_REVIEW) {
    return "text-info";
  } else if (obj === CANDIDATE_STAGE.JD_REVIEW) {
    return "text-info";
  } else if (obj === CANDIDATE_STAGE.S_REVIEW) {
    return "text-info";
  } else if (obj === CANDIDATE_STAGE.IN_PROGRESS) {
    return "text-info";
  }
}

//get offer status
export function getOfferStatus(obj) {
  if (obj === CANDIDATE_STAGE.REVIEWED) {
    return "Reviewed";
  } else if (obj === CANDIDATE_STAGE.S_JD_REVIEW) {
    return "Salary and Joining Date Review";
  } else if (obj === CANDIDATE_STAGE.JD_REVIEW) {
    return "Joining Date Review";
  } else if (obj === CANDIDATE_STAGE.S_REVIEW) {
    return "Salary Review";
  } else if (obj === CANDIDATE_STAGE.IN_PROGRESS) {
    return "In Progress";
  }
}

export const getSource = (source) => {
  const sourceMapping = {
    JOB_PORTAL: "JOB_PORTAL",
    ATS: "ATS",
    // Add more source mappings here
  };

  if (sourceMapping.hasOwnProperty(source)) {
    return sourceMapping[source];
  } else {
    return "Unknown Source";
  }
};

//for making first letter capital in a word
export const capitalizaFirstLetter = (word) => {
  if (verifyData(word)) {
    return word[0].toUpperCase() + word.slice(1).toLowerCase();
  } else {
    return "NA";
  }
};
//extract company id from linkedin company url
export const getCurrentCompanyID = (linkedinURL) => {
  try {
    // Create a URL object from the input string
    const url = new URL(linkedinURL);

    // Get the value of the "currentCompany" parameter
    const currentCompanyParam = url.searchParams.get("currentCompany");

    // Check if the parameter exists and is not empty
    if (currentCompanyParam) {
      // Decode the parameter value and parse it as JSON
      const currentCompanyArray = JSON.parse(
        decodeURIComponent(currentCompanyParam),
      );

      // Check if it's an array and contains at least one element
      if (
        Array.isArray(currentCompanyArray) &&
        currentCompanyArray.length > 0
      ) {
        // Extract the first element as the current company ID
        return currentCompanyArray[0];
      }
    }
  } catch (error) {}

  // Return a default value if the parsing fails or the URL structure is unexpected
  return null;
};

// gen unique key
export const generateKey = (pre) => {
  if (verifyData(pre)) {
    return `${pre}_${new Date().getTime()}`;
  } else {
    return v1();
  }
};
//solves sonarqube issue of turning function in to independent statement
export const independentFunction = (conditions, trueValue, falseValue) => {
  if (conditions) {
    return trueValue;
  } else {
    return falseValue;
  }
};

export const basicView = (data) => {
  if (verifyData(data)) {
    return <HireneuronToolTip value={data} someLongText={data} />;
  } else {
    return "";
  }
};

export const candidateView = (object) => {
  return (
    <HireneuronToolTip
      value={object?.candidateName}
      someLongText={object?.candidateName}
      link={`/candidate/${object?.candidateId}`}
    />
  );
};

export const jobView = (object) => {
  return (
    <HireneuronToolTip
      value={object?.jobProfile}
      someLongText={object?.jobProfile}
      link={`/job/${object?.jobId}/process?stage=ALL`}
    />
  );
};

export const smViewInTable = (object) => {
  return (
    <HireneuronToolTip
      value={object?.shortlistManagerName}
      someLongText={object?.shortlistManagerName}
    />
  );
};

export const statusViewInTable = (object) => {
  if (object?.status === CANDIDATE_STAGE.ACCEPTED) {
    return <span className="text-success">Accepted</span>;
  } else if (
    object?.status === CANDIDATE_STAGE.IN_PROGRESS ||
    object?.status === CANDIDATE_STAGE.INPROGRESS
  ) {
    return <span className="text-info">In progress</span>;
  } else if (object?.status === CANDIDATE_STAGE.REJECTED) {
    return <span className="text-danger">Rejected</span>;
  } else if (object?.status === CANDIDATE_STAGE.HOLD) {
    return <span className="text-warning">Hold</span>;
  } else if (object?.status === CANDIDATE_STAGE.COMPLETED) {
    return <span className="text-success">Completed</span>;
  } else if (object?.status === CANDIDATE_STAGE.OVERRIDE) {
    return <span className="text-warning">Override</span>;
  } else if (object?.status === CANDIDATE_STAGE.SCHEDULED) {
    return <span className="text-primary">Scheduled</span>;
  } else if (object?.status === CANDIDATE_STAGE.CANCELLED) {
    return <span className="text-Secondary">Cancelled</span>;
  } else if (object?.status === CANDIDATE_STAGE.HIRED) {
    return <span className="text-success">Hired</span>;
  } else if (object?.status === CANDIDATE_STAGE.RECEIVED) {
    return <span className="text-success">Received</span>;
  } else if (object?.status === CANDIDATE_STAGE.APPROVED) {
    return <span className="text-success">Approved</span>;
  } else if (object?.status === CANDIDATE_STAGE.DELETED) {
    return <span className="text-danger">Deleted</span>;
  } else if (object?.status === CANDIDATE_STAGE.REVOKED) {
    return <span className="text-secondary">Revoked</span>;
  } else if (object?.status === CANDIDATE_STAGE.REVIEWED) {
    return <span className="text-info">Reviewed</span>;
  } else if (object?.status === CANDIDATE_STAGE.JD_REVIEW) {
    return <span className="text-info">Joining Date Review</span>;
  } else if (object?.status === CANDIDATE_STAGE.S_JD_REVIEW) {
    return <span className="text-info">Joining Date Salary Review</span>;
  } else if (object?.status === CANDIDATE_STAGE.S_REVIEW) {
    return <span className="text-info">Salary Review</span>;
  }
  return <span className="text-warning">NA</span>;
};

export const candidateAssessmentStatusInTable = (object) => {
  if (object?.candidateAssessmentStatus === CANDIDATE_STAGE.ACCEPTED) {
    return <span className="text-success">Accepted</span>;
  } else if (
    object?.candidateAssessmentStatus === CANDIDATE_STAGE.IN_PROGRESS
  ) {
    return <span className="text-info">Pending</span>;
  } else if (object?.candidateAssessmentStatus === CANDIDATE_STAGE.REJECTED) {
    return <span className="text-danger">Rejected</span>;
  } else if (object?.candidateAssessmentStatus === CANDIDATE_STAGE.HOLD) {
    return <span className="text-warning">Hold</span>;
  } else if (object?.candidateAssessmentStatus === CANDIDATE_STAGE.COMPLETED) {
    return <span className="text-success">Completed</span>;
  } else if (object?.candidateAssessmentStatus === CANDIDATE_STAGE.OVERRIDE) {
    return <span className="text-warning">Override</span>;
  }
  return <span className="text-warning">NA</span>;
};

export const dateViewInTable = (object) => {
  if (
    object?.date == null ||
    object?.date === undefined ||
    object?.date === ""
  ) {
    return <span className="text-warning">NA</span>;
  }
  return (
    <HireneuronToolTip
      value={moment(object?.date).format("lll")}
      someLongText={moment(object?.date).format("lll")}
    />
  );
};

export const customdateViewInTable = (date) => {
  if (date == null || date === undefined || date === "") {
    return <span className="text-warning">NA</span>;
  }
  return (
    <HireneuronToolTip
      value={moment(date).format("lll")}
      someLongText={moment(date).format("lll")}
    />
  );
};

/**
 * This Function Returns the icon based on its status of processed files
 * @param {String} status
 *
 */
export const getSymbols = (status) => {
  if (status === "0") {
    return (
      <div style={subloaderStyle}>
        <Spinner style={subspinnerStyle} className="m-4" color="primary" />
      </div>
    );
  } else if (status === "1") {
    return (
      <i className="fas fa-check mr-1 ml-1" style={{ color: "green" }}></i>
    );
  } else if (status === "2") {
    return <i className="fas fa-times mr-1 ml-1" style={{ color: "red" }}></i>;
  }
};

export const scrollIntoView = (elementId) => {
  document.getElementById(elementId).scrollIntoView({
    block: "end",
    behavior: "smooth",
    inline: "nearest",
  });
};
